import React, { useState } from 'react';
import './App.css';
import DoctorForm from './components/DoctorForm';
import ContentDisplay from './components/ContentDisplay';
import LoadingSpinner from './components/LoadingSpinner';

function App() {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleContentGenerated = (newContent) => {
    setContent(newContent);
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
  };

  return (
    <div className="App">
      {/* Animated Background Particles */}
      <div className="particles">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>

      {/* Header */}
      <header>
        <div className="header-icon">🩺</div>
        <h1>Medical Content Generator</h1>
        <p>AI-Powered • Ethical • Indian Medical Council Compliant</p>
        <div className="header-badge">
          <span className="pulse-dot"></span>
          Powered by Groq AI - Llama 3.3 70B
        </div>
      </header>

      {/* Success Toast */}
      {showSuccess && (
        <div className="toast-success">
          <span className="toast-icon">✅</span>
          Content generated successfully!
        </div>
      )}

      {/* Main Content */}
      <div className="container">
        <DoctorForm 
          onContentGenerated={handleContentGenerated} 
          setLoading={setLoading} 
        />
        
        {loading && <LoadingSpinner />}
        
        {content && !loading && <ContentDisplay content={content} />}
      </div>

      {/* Stats Section */}
      <div className="stats-container">
        <div className="stat-card">
          <div className="stat-icon">⚡</div>
          <div className="stat-value">3-5s</div>
          <div className="stat-label">Generation Time</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🎯</div>
          <div className="stat-value">6+</div>
          <div className="stat-label">Platforms Supported</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🔒</div>
          <div className="stat-value">100%</div>
          <div className="stat-label">MCI Compliant</div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🇮🇳</div>
          <div className="stat-value">15+</div>
          <div className="stat-label">Indian Cities</div>
        </div>
      </div>

      {/* Features Section */}
      <div className="features-section">
        <h2 className="features-title">✨ Key Features</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🤖</div>
            <h3>AI-Powered</h3>
            <p>Advanced Llama 3.3 model for intelligent content creation</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">⚖️</div>
            <h3>Ethics First</h3>
            <p>Compliant with Indian Medical Council regulations</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🌐</div>
            <h3>Multi-Platform</h3>
            <p>Generate for Instagram, WhatsApp, LinkedIn & more</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🇮🇳</div>
            <h3>India-Focused</h3>
            <p>Context-aware content for Indian healthcare</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🌡️</div>
            <h3>Seasonal Aware</h3>
            <p>Adapts to climate and seasonal health concerns</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📱</div>
            <h3>Mobile Friendly</h3>
            <p>Responsive design for all devices</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer>
        <div className="footer-content">
          <div className="footer-badge">
            ⚕️ Compliant with ICMR & Indian Medical Council Guidelines
          </div>
          <div className="footer-links">
            <span>Made with ❤️ for Indian Healthcare</span>
            <span className="separator">•</span>
            <span>© 2026 Medical Content AI</span>
          </div>
          <div className="footer-tech">
            <span className="tech-badge">React</span>
            <span className="tech-badge">Groq AI</span>
            <span className="tech-badge">Llama 3.3</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
